"use client";

import { CheckCircle, GraduationCap, Search, Settings, Users, Users2 } from "lucide-react";
import ProcessFlowchart from "./ProcessFlowchart";

export default function ClassroomMappingFlowchart() {
  const steps = [
    { id: 1, title: "Select Class & Section", description: "Choose the class and section for assignment", icon: <GraduationCap className="h-5 w-5" />, color: "bg-blue-500" },
    { id: 2, title: "Choose Assignment Type", description: "Select Teacher Management or Student Management", icon: <Users2 className="h-5 w-5" />, color: "bg-purple-500" },
    { id: 3, title: "For Teachers", description: "Select teacher, type (class/subject), and assign subjects", icon: <Users className="h-5 w-5" />, color: "bg-green-500" },
    { id: 4, title: "For Students", description: "Select student and assign to class-section", icon: <Users className="h-5 w-5" />, color: "bg-yellow-500" },
    { id: 5, title: "Save Assignment", description: "Click Save Assignment to create the mapping", icon: <CheckCircle className="h-5 w-5" />, color: "bg-indigo-500" },
    { id: 6, title: "View Assignments", description: "View by Teachers/Students or by Classes", icon: <Search className="h-5 w-5" />, color: "bg-orange-500" },
    { id: 7, title: "Manage Assignments", description: "Edit or delete assignments as needed", icon: <Settings className="h-5 w-5" />, color: "bg-teal-500" },
  ];

  const footer = (
    <div className="mt-6 pt-4 border-t border-green-200">
      <h4 className="text-sm font-semibold text-gray-700 mb-3">Teacher Types:</h4>
      <div className="flex flex-wrap gap-3">
        <div className="flex items-center gap-2"><div className="w-4 h-4 rounded-full bg-green-500"></div><span className="text-xs text-gray-600">Class Teacher - Overall class management</span></div>
        <div className="flex items-center gap-2"><div className="w-4 h-4 rounded-full bg-blue-500"></div><span className="text-xs text-gray-600">Subject Teacher - Teaches specific subjects</span></div>
      </div>
    </div>
  );

  return (
    <ProcessFlowchart
      title="Classroom Mapping Process Flowchart"
      titleIcon={<GraduationCap className="h-5 w-5 text-green-600" />}
      steps={steps}
      footer={footer}
    />
  );
}
